export default __webpack_public_path__ + "static/media/card2.651e7032.png";